<form [formGroup]="formCustomer" class="form-horizontal">
  <div class="form-group row">
    <div class="col-md-4">
      <label class="col-form-label"><b>Cliente</b></label>
      <div class="input-group">
        <input type="text" id="text-input" name="text-input" class="form-control" formControlName="customerFullName"
          [class.is-invalid]="(formCustomer?.get('customerFullName')?.touched || formCustomer?.get('customerFullName')?.dirty) && formCustomer?.get('customerFullName')?.invalid"
          readonly required>
        <span *ngIf="!isForRecollection" class="input-group-append">
          <button type="button" class="btn btn-outline-primary" (click)="createCustomer()" *ngIf="showCreateCustomer">
            Crear Cliente
          </button>
        </span>
      </div>
    </div>
    <div class="col-md-4" [hidden]="onlyCustomer" *ngIf="!isForRecollection">
      <label class=" col-form-label" for="text-input"><b>Vendedor</b></label>
      <div class="input-group">
        <input type="text" id="text-input" name="text-input" class="form-control" formControlName="sellerName"
          [class.is-invalid]="
            (formCustomer?.get('sellerName')?.touched ||
              formCustomer?.get('sellerName')?.dirty) &&
            formCustomer?.get('sellerName')?.invalid
          " required />
      </div>
    </div>
    <div class="col-md-4" [hidden]="onlyCustomer" *ngIf="!isForRecollection">
      <label class="col-form-label"><b>RTN</b></label>
      <div class="input-group">
        <input type="text" id="text-input" name="text-input" class="form-control" formControlName="rtnFiscalId"
          [class.is-invalid]="
            (formCustomer?.get('rtnFiscalId')?.touched ||
              formCustomer?.get('rtnFiscalId')?.dirty) &&
            formCustomer?.get('customerFullName')?.invalid
          " />
        <span class="input-group-append">
          <button type="button" class="btn btn-outline-primary" [disabled]="disableRtnButton()"
            (click)="updateRtnFiscalId()">
            Utilizar RTN
          </button>
        </span>
      </div>
    </div>
    <div class="col-md-4" *ngIf="isForRecollection">
      <label class="col-form-label"><b>Contrato</b></label>
      <div class="input-group">
        <input type="text" id="text-input" name="text-input" class="form-control" formControlName="contractNumber"
          [class.is-invalid]="(formCustomer?.get('contractNumber')?.touched || formCustomer?.get('contractNumber')?.dirty) && formCustomer?.get('customerFullName')?.invalid"
          (keyup.enter)="handleSearchByContractNumber($event)">
      </div>
    </div>
  </div>
</form>
<pos-customer-table (getCustomer)="selectCustomer($event)"
  [showVerificationAlert]="showVerifyAlert"></pos-customer-table>